module.exports = __webpack_public_path__ + "img/005.5a8dd722.png";